import ky from "ky";

import { CorrelationId } from "~/services/correlation-id";
import Logger from "~/services/logger/logger";
import { ApiConstants } from "~/shared/api/api-constants.class";

const $fetch = ky.extend({
  hooks: {
    beforeRequest: [
      (request, options, { retryCount }) => {
        // $fetch is also used to call third parties (e.g. Woosmap), which must not receive our correlation id.
        if (ApiConstants.isInternalUrl(request.url)) {
          request.headers.set(ApiConstants.headers.X_CORRELATION_ID, CorrelationId.get());
        }
        Logger.instance.info(`New request: ${request.url} | (retry #: ${retryCount})`);
      },
    ],
    beforeError: [
      async (error) => {
        Logger.instance.error(error);
        return error;
      },
    ],
  },
});

export default $fetch;
